// extracted by css-extract-rspack-plugin
export default {"floatButton":"jPNC8I8b","floatButtonDisabled":"jaf1mujA"};